import React, { useEffect, createElement } from 'react';
import { Download, Sparkles } from 'lucide-react';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function MeditationsPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-2138">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-2139">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-2140" />
      </noscript>

      {/* Background Image Layer */}
      <div className="absolute top-0 left-0 w-full h-[400px] md:h-[600px] z-0 opacity-60" data-id="element-2141">
        <img src="https://cdn.magicpatterns.com/uploads/owSR6X5Pw8KuRfkif7sGzk/6936d7f7169a421d1ba8a294.png" alt="Background Pattern" className="w-full h-full object-cover mask-image-gradient" style={{
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)'
      }} data-id="element-2142" />
      </div>

      {/* Main Content */}
      <main className="relative z-10 max-w-4xl mx-auto px-4 py-12 md:py-20 flex flex-col items-center text-center" data-id="element-2143">
        {/* Icon */}
        <div className="mb-6 md:mb-8" data-id="element-2144">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-[#00f7fc] to-[#00d7dc] rounded-full flex items-center justify-center shadow-lg shadow-[#00f7fc]/30" data-id="element-2145">
            <Sparkles className="w-8 h-8 md:w-10 md:h-10 text-black" data-id="element-2146" />
          </div>
        </div>

        {/* Headline */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4 md:mb-6" data-id="element-2147">
          Descarga Tus{' '}
          <span className="text-[#00f7fc]" data-id="element-2148">Meditaciones Guiadas</span>
        </h1>

        {/* Subtitle */}
        <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-8 md:mb-12" data-id="element-2149">
          Accede a tu colección exclusiva de meditaciones diseñadas para
          ayudarte a encontrar claridad, enfoque y paz interior.
        </p>

        {/* Download Card */}
        <div className="w-full max-w-2xl mb-8 md:mb-12" data-id="element-2150">
          <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-[#00f7fc]/30 rounded-2xl p-6 md:p-8 shadow-2xl" data-id="element-2151">
            {/* Glow effect */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/20 rounded-2xl blur-xl opacity-50" data-id="element-2152"></div>

            <div className="relative" data-id="element-2153">
              <h2 className="text-xl md:text-2xl font-bold mb-4 text-white" data-id="element-2154">
                Meditaciones Completas
              </h2>
              <p className="text-gray-400 mb-6 text-sm md:text-base" data-id="element-2155">
                Archivo completo con todas las sesiones de meditación guiada
                para tu práctica diaria.
              </p>

              {/* Download Button */}
              <a href="https://drive.google.com/file/d/1IZLjqcG6MBdZvP6hKnJIwgQFHGDnKnwb/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-b from-[#00f7fc] to-[#00d7dc] hover:from-[#00d7dc] hover:to-[#00b8bc] text-black font-black text-lg md:text-xl uppercase tracking-wide rounded-xl py-4 md:py-5 px-6 shadow-[0_0_30px_rgba(0,247,252,0.4)] transition-all duration-300 transform hover:scale-[1.02] flex items-center justify-center gap-3" data-id="element-2156">
                <Download className="w-6 h-6" data-id="element-2157" />
                Descargar Meditaciones
                {/* Shine effect */}
                <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-2158">
                  <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-2159" />
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="w-full max-w-3xl" data-id="element-2160">
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6 md:p-8" data-id="element-2161">
            <h3 className="text-lg md:text-xl font-bold mb-4 text-center" data-id="element-2162">
              Beneficios de la Práctica Regular
            </h3>
            <div className="grid md:grid-cols-2 gap-4 text-left" data-id="element-2163">
              <div className="flex items-start gap-3" data-id="element-2164">
                <div className="w-2 h-2 bg-[#00f7fc] rounded-full mt-2 flex-shrink-0" data-id="element-2165"></div>
                <p className="text-gray-300 text-sm md:text-base" data-id="element-2166">
                  Reduce el estrés y la ansiedad
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-2167">
                <div className="w-2 h-2 bg-[#00f7fc] rounded-full mt-2 flex-shrink-0" data-id="element-2168"></div>
                <p className="text-gray-300 text-sm md:text-base" data-id="element-2169">
                  Mejora la concentración y claridad mental
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-2170">
                <div className="w-2 h-2 bg-[#00f7fc] rounded-full mt-2 flex-shrink-0" data-id="element-2171"></div>
                <p className="text-gray-300 text-sm md:text-base" data-id="element-2172">
                  Aumenta la paz interior y bienestar
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-2173">
                <div className="w-2 h-2 bg-[#00f7fc] rounded-full mt-2 flex-shrink-0" data-id="element-2174"></div>
                <p className="text-gray-300 text-sm md:text-base" data-id="element-2175">
                  Desarrolla mindfulness y presencia
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="mt-8 md:mt-12 max-w-2xl" data-id="element-2176">
          <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-4 md:p-6" data-id="element-2177">
            <h4 className="font-bold text-white mb-2 text-sm md:text-base" data-id="element-2178">
              Instrucciones de Descarga:
            </h4>
            <ol className="text-left text-gray-300 text-xs md:text-sm space-y-2 list-decimal list-inside" data-id="element-2179">
              <li data-id="element-2180">Haz clic en el botón "Descargar Meditaciones"</li>
              <li data-id="element-2181">Se abrirá Google Drive en una nueva pestaña</li>
              <li data-id="element-2182">
                Haz clic en el botón de descarga en la esquina superior derecha
              </li>
              <li data-id="element-2183">Guarda el archivo en tu dispositivo</li>
              <li data-id="element-2184">Disfruta de tus meditaciones cuando lo desees</li>
            </ol>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer data-id="element-2185" />
    </div>;
}